import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers,
  getQuestionsByCategory,
  getSourceSystemContent
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  questionRoutingLabels
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { getDefaultAnswers } from "../../../helpers";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useKeys() {
  const QUESTION_ID = QuestionIds.KEYS;
  const NEXT_QUESTION_PATH = questionRoutingLabels[QuestionIds.SERVICEHISTORY];
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];
  const factualQuestion = useSelector(getQuestionById("Factual", QUESTION_ID));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assumptionQuestions = useSelector(getQuestionsByCategory("Assumption"));
  const defaultAssumptions = getDefaultAnswers(assumptionQuestions);
  const { quickValuation } = useSelector(getSourceSystemContent);

  const { pageTitle } = questionPresentationContent[QUESTION_ID];

  const handleSubmit = (answer: string | null) => {
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }

    if (!quickValuation) {
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers(defaultAssumptions)
      );
    }

    sendEvent("event", "interaction", {
      action: factualQuestion.content,
      label: setAnalyticsLabel(factualQuestion, answer[0]),
    });

    navigate(`/${NEXT_QUESTION_PATH}`);
  };

  return {
    question: factualQuestion,
    questionTitle: factualQuestion.content,
    pageTitle,
    handleSubmit,
    answer
  };
}

export default useKeys;
